import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Bar } from "react-chartjs-2";
import Chart from 'chart.js/auto';
import Ticket from "../Components/Ticket";
import { FaPlusCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";

function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);
  const [chartData, setChartData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const { state } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      if (state.role === "admin") {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/tickets/account/${state.account}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        setTickets(response.data.tickets);
        setCount(response.data.count);
        setIsLoading(false);
      } else if (state.role === "root") {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/tickets`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        setTickets(response.data.tickets);
        setCount(response.data.count);
        setChartData(response.data.data);
        setIsLoading(false);
      } else if (state.role === "support") {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_BACKEND_URL}/tickets/technician/${state.userId}`,
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        setTickets(response.data.tickets);
        setCount(response.data.count);
        setIsLoading(false);
      } else {
        setTickets([]);
      }
    }
    fetch();
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
      title: {
        display: true,
        text: `${count} tickets en los últimos 30 días `,
      },
    },
  };

  if (isLoading) {
    return <Spinner />;
  } else {
    if (count > 0) {
      return (
        <Col className="tickets">
          <Col className="tickets-header">
            <Row className="align-items-center">
              <Col lg={9}>
                <h3>Tickets de soporte</h3>
              </Col>
              <Col lg={3} className="right icon">
                <FaPlusCircle onClick={() => navigate("/new-ticket")} />
              </Col>
            </Row>
          </Col>
          {state.role === "root" ? (
            <Col className="tickets-chart">
              <Col>
                <Bar data={chartData} options={options} />
              </Col>
            </Col>
          ) : (
            <></>
          )}

          <Row>
            <Col>
              {tickets.map((item) => (
                <Ticket
                  description={item.description}
                  title={item.title}
                  id={item._id}
                  key={item._id}
                  date={item.closed_at}
                  accountName={item.accountName}
                  status={item.status}
                  supportClosed={item.supportClosed}
                  role={state.role}
                />
              ))}
            </Col>
          </Row>
        </Col>
      );
    } else {
      return (
        <Col className="tickets">
          <Col className="tickets-empty">
            <h4 className="mb-3">No hay tickets reportados</h4>
            <Button onClick={() => navigate("/new-ticket")} variant="info">
              Crear primer ticket
            </Button>
          </Col>
        </Col>
      );
    }
  }
}

export default Tickets;
